<div
  class="multi-account"
  *ngIf="!isAdmin && allCompanies && allCompanies.length > 1"
>
  <!-- <h4 class="mb-3">{{ company }}</h4> -->
  <div class="dropdown">
    <input
      class="btn btn-secondary p-3 w-100 rounded-4"
      type="text"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      ngbTooltip="Switch Company"
      tooltipClass="custom-tooltip"
      [placeholder]="isFocused ? 'Search Company' : (company && company.length > 18 ?  company.slice(0, 15) + '...' : company)"
      [value]="searchText"
      (input)="searchCompany($event)"
      (focus)="isFocused = true"
    />
    <span class="mt-1 position-absolute end-0 top-0 p-2 rotate">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="M12 14.975q-.2 0-.375-.062T11.3 14.7l-4.6-4.6q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l3.9 3.9l3.9-3.9q.275-.275.7-.275t.7.275t.275.7t-.275.7l-4.6 4.6q-.15.15-.325.213t-.375.062"
        />
      </svg>
    </span>
    <!-- <div class="position-absolute bg-loader" *ngIf="isSwitch">
        <div class="spinner-border text-primary-2" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div> -->
    <div class="dropdown-menu border-0 dropdown-menu-start">
      <div class="max-h-account" *ngIf="!isSwitch">
        <div
          class="account rounded-0 p-3 m-2 border-bottom-1 border-light-subtle"
          *ngFor="let customer of companies"
        >
          <div
            (click)="switchCustomer(customer)"
            role="button"
            class="cursor-pointer"
          >
            <p
              class="text-success fw-light fs-6 mb-2"
              *ngIf="customer.id === currentUser"
            >
              Currently Selected
            </p>
            <p class="text-dark fw-regular mt-1 fs-5">
              {{ customer.customer?.name }}
              <span class="badge bg-brown-25 fs-6 mb-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <circle cx="10" cy="10" r="2" fill="currentColor"></circle>
                </svg>
                {{ customer.userRole?.name }}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
